import React, { useState } from "react";
import FiltersTrackCase, {
  FiltersSelectType,
  initialFilterSelect,
  SearchFormDataType,
} from "../reusable/FiltersTrackCase";
import Datatable from "../../../core/common/dataTable";
import { ColumnsType } from "antd/es/table";
import { cellWidth } from "../../../core/methods/tableCellWidth";
import TimelineModal from "../../../core/common/TimelineModal";
import { parseDate, parseNumber } from "../../../core/methods/sorterMethods";
import {
  dummyData_revisedDate,
  timelineData_invite,
} from "../../../core/data/js/dummy-data";
import Footer from "../../../core/common/Footer";

const RevisedDateCases = () => {
  const [itemList, setItemList] = useState(dummyData_revisedDate);
  const [searchFilter, setSearchFilter] = useState<SearchFormDataType>({
    case_id: "",
    applicant_name: "",
    email: "",
    from_date: "",
    to_date: "",
  });
  const [filterData, setFilterData] =
    useState<FiltersSelectType>(initialFilterSelect);

  const [showTimeline, setShowTimeline] = useState<boolean>(false);
  const [showGuide, setShowGuide] = useState<boolean>(false);

  //  ---- columns ----
  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      sorter: (a, b) => a.sno - b.sno,
    },
    {
      title: "Applicant Name",
      dataIndex: "applicantName",
      key: "applicantName",
      onCell: () => cellWidth(200),
      sorter: (a, b) => a.applicantName.localeCompare(b.applicantName),
    },
    {
      title: "Case ID",
      dataIndex: "caseId",
      key: "caseId",
      onCell: () => cellWidth(190),
      sorter: (a, b) => parseNumber(a.caseId) - parseNumber(b.caseId),
    },
    {
      title: "Case Spoc",
      dataIndex: "caseSpoc",
      key: "caseSpoc",
      onCell: () => cellWidth(150),
      sorter: (a, b) => a.caseSpoc.localeCompare(b.caseSpoc),
    },
    {
      title: "Check Name",
      dataIndex: "checkName",
      key: "checkName",
      onCell: () => cellWidth(160),
      sorter: (a, b) => a.checkName.localeCompare(b.checkName),
    },
    {
      title: "Key Value",
      dataIndex: "keyValue",
      key: "keyValue",
      onCell: () => cellWidth(200),
      sorter: (a, b) => a.keyValue.localeCompare(b.keyValue),
    },
    {
      title: "Reason For Delay",
      dataIndex: "reasonForDelay",
      key: "reasonForDelay",
      onCell: () => cellWidth(300),
      sorter: (a, b) => a.reasonForDelay.localeCompare(b.reasonForDelay),
    },
    {
      title: "SLA End Date",
      dataIndex: "slaEndDate",
      key: "slaEndDate",
      onCell: () => cellWidth(150),
      sorter: (a, b) =>
        parseDate(a.expectedDateOfClosure).getTime() -
        parseDate(b.expectedDateOfClosure).getTime(),
    },
    {
      title: "Overdue Days",
      dataIndex: "overdueDays",
      key: "overdueDays",
      sorter: (a, b) => a.overdueDays - b.overdueDays,
    },
    {
      title: "Expected Date Of Closure",
      dataIndex: "expectedDateOfClosure",
      key: "expectedDateOfClosure",
      onCell: () => cellWidth(180),
      sorter: (a, b) =>
        parseDate(a.expectedDateOfClosure).getTime() -
        parseDate(b.expectedDateOfClosure).getTime(),
    },
    {
      title: "View Log",
      dataIndex: "",
      onCell: () => cellWidth(110),
      render: () => (
        <div
          className="text-center text-dark"
          style={{ cursor: "pointer" }}
          onClick={() => setShowTimeline(true)}
        >
          <i className="ti ti-eye "></i>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <>
          {/* Guide Container */}
          {/* <>
        <div className="text-end">
          <Button
            className="border-secodary"
            onClick={() => setShowGuide((prev) => !prev)}
          >
            <i className="ti ti-info-circle-filled fs-16"></i>
            <div className="pb-1 ">Guide</div>
          </Button>
        </div>

        <GuideContentArea
          maxHeight={"180px"}
          showGuide={showGuide}
          handleClick={() => setShowGuide(false)}
          title={"Stopped Cases"}
          content={
            <div>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis
              fugiat veritatis magnam iste odio sunt vitae nobis delectus
              reprehenderit id. Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Doloribus dolorum totam reprehenderit soluta
              ullam saepe quo et rem vitae quidem.
            </div>
          }
        />
      </> */}

          <div className="mt- 3"></div>
          {/* filters */}
          {/* <FiltersTrackCase
            filterData={filterData}
            searchFilter={searchFilter}
            setFilterData={setFilterData}
            setSearchFilter={setSearchFilter}
          /> */}

          {/* Table  */}
          <div className="card mt-3">
            <Datatable
              dataSource={itemList}
              columns={columns}
              Selection={false}
              // pagination={pagination}
              // handleTableChange={handleTableChange}
            />
          </div>

          {/* Timeline */}
          {showTimeline && (
            <TimelineModal
              timelineData={timelineData_invite}
              onClose={() => setShowTimeline(false)}
            />
          )}
        </>
      </div>

      {/* ---- Footer ---- */}
      <Footer />
    </div>
  );
};

export default RevisedDateCases;
